import React, {useEffect, useState} from 'react'
import {Navigate} from 'react-router-dom'
import FooterNavMildiou from './MEP/footer-nav-mildiou'
import EnteteMildiou from './MEP/enete-milidou'
import ring from '../../assets/Milidou/Union.png'
import ringNot from '../../assets/Milidou/bell-slash.png'
import icon from '../../assets/Milidou/inbox.png'
import FlecheB from '../../assets/Milidou/Flechebas.png'
import FlecheH from '../../assets/Milidou/Flechehaut.png'
import plane from '../../assets/Milidou/paper-airplane.png'
import CalendarPrevision from './Graphiques/Calendar-prevision'
import GraphCamembergRDTMildiou from './Graphiques/GraphPieRDT'
import { EventService } from 'ag-grid-community'

function AccueilMildiou() {
  const [CP, setCP] = useState("33400")
  const [idParcelle, setidParcelle] = useState("1")
  const [libelleParcelle, setlibelleParcelle] = useState("Parcelle 1 - référence")
  const [listeParcelle, setlisteParcelle] = useState([{'value': "1", "libelle": "Parcelle 1", "reference":"1"},{'value': "2", "libelle": "Parcelle 2", "reference":"0"},{'value': "3", "libelle": "Ilot Merlot", "reference":"0"}])
  const [dateAlerte2, setdateAlerte2] = useState("2025-05-27")
  const [today, settoday] = useState("2025-05-22")
  const [anneeFixe, setanneeFixe] = useState(2025)
  const [annee, setannee] = useState(2025)
  const [dataPrev, setDataPrev] = useState([["2025-04-01", 0], ["2025-04-02", 0], ["2025-04-03", 0], ["2025-04-04", 0], ["2025-04-05", 0], ["2025-04-06", 0], ["2025-04-07", 0], ["2025-04-08", 0], ["2025-04-09", 0], ["2025-04-10", 0], ["2025-04-11", 0], ["2025-04-12", 0], ["2025-04-13", 0], ["2025-04-14", 0], ["2025-04-15", 0], ["2025-04-16", 0], ["2025-04-17", 0], ["2025-04-18", 0], ["2025-04-19", 0], ["2025-04-20", 0], ["2025-04-21", 0], ["2025-04-22", 0], ["2025-04-23", 0], ["2025-04-24", 0], ["2025-04-25", 0], ["2025-04-26", 0], ["2025-04-27", 0], ["2025-04-28", 0], ["2025-04-29", 0], ["2025-04-30", 0], ["2025-05-01", 0], ["2025-05-02", 0], ["2025-05-03", 0], ["2025-05-04", 0], ["2025-05-05", 0], ["2025-05-06", 0], ["2025-05-07", 0], ["2025-05-08", 0], ["2025-05-09", 0], ["2025-05-10", 0], ["2025-05-11", 0], ["2025-05-12", 0], ["2025-05-13", 0], ["2025-05-14", 0], ["2025-05-15", 0], ["2025-05-16", 0], ["2025-05-17", 1], ["2025-05-18", 1], ["2025-05-19", 1], ["2025-05-20", 1], ["2025-05-21", 1], ["2025-05-22", 1], ["2025-05-23", 1], ["2025-05-24", 1], ["2025-05-25", 1], ["2025-05-26", 1], ["2025-05-27", 2], ["2025-05-28", 2], ["2025-05-29", 3], ["2025-05-30", 3], ["2025-05-31", 3], ["2025-06-01", 3], ["2025-06-02", 3], ["2025-06-03", 3], ["2025-06-04", 3], ["2025-06-05", 3], ["2025-06-06", 3], ["2025-06-07", 3], ["2025-06-08", 3], ["2025-06-09", 3], ["2025-06-10", 3], ["2025-06-11", 3], ["2025-06-12", 3], ["2025-06-13", 3], ["2025-06-14", 3], ["2025-06-15", 3]]);
  const [dataRDT, setdataRDT] = useState([{ value: 17.9, name: 'Pertes Climatique' },{ value: 19.5, name: 'Pertes Milidou' },{ value: 62.6, name: 'Récolte résiduelle' }])
  const [dataRDT_N, setdataRDT_N] = useState([{ value: 17.9, name: 'Pertes Climatique' },{ value: 19.5, name: 'Pertes Milidou' },{ value: 62.6, name: 'Récolte résiduelle' }])
  const [dataRDT_N_1, setdataRDT_N_1] = useState([{ value:20.9, name: 'Pertes Climatique' },{ value: 23.5, name: 'Pertes Milidou' },{ value: 55.6, name: 'Récolte résiduelle' }])
  const [dataRDT_N_2, setdataRDT_N_2] = useState([{ value:38.9, name: 'Pertes Climatique' },{ value: 20.5, name: 'Pertes Milidou' },{ value: 40.6, name: 'Récolte résiduelle' }])
  const [dataRDT_N_3, setdataRDT_N_3] = useState([{ value:41.7, name: 'Pertes Climatique' },{ value: 0, name: 'Pertes Milidou' },{ value: 58.3, name: 'Récolte résiduelle' }])
  const [rdtObjectif, setrdtObjectif] = useState(120)
  const [rdtPotentiel, setrdtPotentiel] = useState(75.1)
  const [tauxMax, settauxMax] = useState(75)
  const [tauxMax_N, settauxMax_N] = useState(75)
  const [tauxMax_N_1, settauxMax_N_1] = useState(100)
  const [tauxMax_N_2, settauxMax_N_2] = useState(100)
  const [tauxMax_N_3, settauxMax_N_3] = useState(0)
  const [dateTauxMax, setdateTauxMax] = useState("2025-06-22")
  const [dateTauxMax_N, setdateTauxMax_N] = useState("2025-06-22")
  const [dateTauxMax_N_1, setdateTauxMax_N_1] = useState("2024-07-07")
  const [dateTauxMax_N_2, setdateTauxMax_N_2] = useState("2023-06-20")
  const [dateTauxMax_N_3, setdateTauxMax_N_3] = useState("/")
  const [showQuest, setshowQuest] = useState(false)
  const [QmildiouApparu, setQmildiouApparu] = useState()
  const [QdateApparition, setQdateApparition] = useState()
  const [Qtraite, setQtraite] = useState()
  const [QdateTrait, setQdateTrait] = useState()
  const [QpertinencePreditc, setQpertinencePreditc] = useState(4)
  const [Qcommentaire, setQcommentaire] = useState()

  const SearchAlerte = (today, dataPrev) => {
    var entry = dataPrev.find(([date]) => date === today);
    return entry ? entry[1] : null
  }

  const TextAlerte = (today, dataPrev) => {
    if (SearchAlerte(today, dataPrev) === 0 ) {
      return "Risque quasi nul"
    }
    else if (SearchAlerte(today, dataPrev) === 1 ) {
      return "Risque faible"
    }
    else if (SearchAlerte(today, dataPrev) === 2 ) {
      return "Risque local fort"
    }
    else {
      return "Risque généralisé"
    }
  }
  const CouleurAlerte = (today, dataPrev) => {
    if (SearchAlerte(today, dataPrev) === 0 ) {
      return "#DFFFF9"
    }
    else if (SearchAlerte(today, dataPrev) === 1 ) {
      return "#D4EA62"
    }
    else if (SearchAlerte(today, dataPrev) === 2 ) {
      return "#F4C842"
    }
    else {
      return "#F0907F"
    }
  }

  function handleChange(event){
    let anneeValue = parseFloat(event.target.value)
    setannee(anneeValue)
    if (anneeValue === anneeFixe){
      setdataRDT(dataRDT_N)
      settauxMax(tauxMax_N)
      setdateTauxMax(dateTauxMax_N)
    }
    else if (anneeValue === (anneeFixe - 1)){
      setdataRDT(dataRDT_N_1)
      settauxMax(tauxMax_N_1)
      setdateTauxMax(dateTauxMax_N_1)
    }
    else if (anneeValue === (anneeFixe - 2)){
      setdataRDT(dataRDT_N_2)
      settauxMax(tauxMax_N_2)
      setdateTauxMax(dateTauxMax_N_2)
    }
    else {
      setdataRDT(dataRDT_N_3)
      settauxMax(tauxMax_N_3)
      setdateTauxMax(dateTauxMax_N_3)
    }
  }

  function handleChangeParcelle(event){
    var parcelle = event.currentTarget.value
    var libelle = event.target.options[event.target.selectedIndex].text;
    setidParcelle(parcelle) 
    setlibelleParcelle(libelle)
  }
  function formatDate(dateString) {
    const mois = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];
    
    const [year, month, day] = dateString.split("-"); // Sépare l'année, le mois et le jour
    return `${parseInt(day)} ${mois[parseInt(month) - 1]}`; // Convertit le mois en texte
  }
  function handleshow(){
    showQuest ? setshowQuest(false) : setshowQuest(true)
  }
  function handleChangeQmildiouApparu(event){
    var resp=event.target.value
    setQmildiouApparu(resp)
  }
  function handleChangeQtrait(event){
    var resp=event.target.value
    setQtraite(resp)
  }
  function handleChangePertience(event){
    var perti = event.target.value
    setQpertinencePreditc(perti)
  }
  function handleChangeCommentaire(event){
    var com = event.target.value
    setQcommentaire(com)
  }
  function handleChangeDateObser(event){
    var dateobs = event.target.value
    setQdateApparition(dateobs)
  }
  function handleChangeDateTrait(event){
    var datetrait = event.target.value
    setQdateTrait(datetrait)
  }

  return (
    <div>
      <EnteteMildiou titre={'Accueil'}/>
      <FooterNavMildiou/>
      <div className='containerMildiouSansMarge'> 
        <div style={{backgroundColor:'#EAF5FE', width:'100hw'}}>
          <div style={{display:'flex', flexDirection:'row', justifyContent:'space-around'}} >
            <div style={{width:'45%', padding:'2%'}}>
              <div className='titreMoins' style={{margin:'0px', fontWeight:'600'}}> Code postal : {CP}</div>
              <select 
                className='input_assol dateSemisUneCulture'
                value={idParcelle} 
                onChange={handleChangeParcelle}  
                style={{width:'100%', border:"solid 2px black", height:'80px', textAlign:'left', padding:'3%'}} >
                  {listeParcelle.map((item)=>( <option key={item.value} value={item.value} > {item.reference === "1" ? item.libelle + " - référence" : item.libelle} </option> ) )}
              </select>
            </div>
            <div style={{width:'45%', padding:'2%'}}>
              <div className='titreMoins' style={{margin:'0px', fontWeight:'600'}}> Aujourd'hui</div>
              <div className='titreMoins' style={{margin: '0px', width:'80%', border:"solid 2px black", height:'60px', textAlign:'center', padding:'3%', borderRadius:"10px", backgroundColor:CouleurAlerte(today,dataPrev), display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
                <img src={SearchAlerte(today, dataPrev) === 0 ? ringNot : ring} alt="alerte" style={{height:'60%'}}/>
                <div className='titreMoins' style={{margin: '0px', marginLeft:'5%'}}> {TextAlerte(today, dataPrev)} </div>
              </div>  
            </div>  
          </div>
          <div style={{width:'45%', padding:'2%', paddingTop:'0px', display:'flex', justifyContent:'center', alignItems: 'center', flexDirection:'column'}}>
            <div className='titreMoins' style={{margin:'0px', fontWeight:'600', marginBottom:'10px'}}>  Symptome, 1ère apparition </div>
            <div className='titreMoins' style={{margin: '0px', width:'80%', border:"solid 2px black", height:'60px', textAlign:'center', padding:'3%', borderRadius:"10px", backgroundColor:'#F4C842'}}>{formatDate(dateAlerte2)}</div>  
          </div>
        </div>
        <div style={{padding:'2%'}}>
          <div className='titre' style={{margin:'0px'}}>Prévision Mildiou</div>
          <div className='titreMoins' style={{marginTop:'5px'}}>{libelleParcelle}</div>
        </div>
        {dataPrev !== undefined ?
          <CalendarPrevision data={dataPrev} today={today}/>
        : "" }
        <div style={{paddingLeft:'5%', paddingRight:'2%'}}>
          <div style={{display:'flex', flexDirection:'row', justifyContent:'space-around', width:'90%'}} >
            <div style={{display:'flex', flexDirection:'row', justifyContent:'space-around', alignItems:'center', width:'50%'}} >
              <div className='carreLegend' style={{backgroundColor:"#DFFFF9"}}>
                {/*laisser vide */}
              </div>
              <div className='paragraphe' style={{width:'85%', padding:'2%'}}>
                Risque quasi-nul
              </div>
            </div>
            <div style={{display:'flex', flexDirection:'row', justifyContent:'space-around', alignItems:'center', width:'50%'}} >
              <div className='carreLegend' style={{backgroundColor:"#D4EA62"}}>
                {/*laisser vide */}
              </div>
              <div className='paragraphe' style={{width:'85%', padding:'2%'}}>
                Risque faible : protection préventive
              </div>
            </div>
          </div>
        </div>
        <div style={{paddingLeft:'5%', paddingRight:'2%'}}>
          <div style={{display:'flex', flexDirection:'row', justifyContent:'space-around', width:'90%'}} >
            <div style={{display:'flex', flexDirection:'row', justifyContent:'space-around', alignItems:'center', width:'50%'}} >
              <div className='carreLegend' style={{backgroundColor:"#F4C842"}}>
                {/*laisser vide */}
              </div>
              <div className='paragraphe' style={{width:'85%', padding:'2%'}}>
                Risque local fort : protection conseillée
              </div>
            </div>
            <div style={{display:'flex', flexDirection:'row', justifyContent:'space-around', alignItems:'center', width:'50%'}} >
              <div className='carreLegend' style={{backgroundColor:"#F0907F"}}>
                {/*laisser vide */}
              </div>
              <div className='paragraphe' style={{width:'85%', padding:'2%'}}>
                Risque généralisé : protection recommandée
              </div>
            </div>
          </div>
        </div>

        <button className='ButtonHome row' style={{justifyContent:'flex-start', width:'100%', marginTop:'20px'}}>
          <img src={icon} alt="icon décorative" style={{width:'8%', marginLeft:'4%'}}/>
          <div className='paragraphe' style={{fontWeight:'bold', color:'#C61717', marginLeft:'15px', textDecoration:'underline'}}>Voir alertes année antérieures</div>
        </button>

        <div className='row' style={{backgroundColor:'#FFDBDB', width:'100hw', padding:'2%', justifyContent:'space-between', margin:'0px'}}>
          <div className='titre' style={{width:'85%', margin:'0px', marginBottom:'0px', color:'#C61717'}}>Quand est apparu le mildiou  sur votre parcelle ou ilot de référence ? *</div>
          <button className='ButtonHome' onClick={handleshow} style={{width:'10%'}}><img src={showQuest ? FlecheH : FlecheB} alt="flèche vers le bas" style={{width:'80%'}}/></button>
        </div>
        <div className={showQuest ? 'ShowResult' : 'HideResult'} style={{backgroundColor:'#FFF7F7', width:'100hw', marginBottom:'20px', padding:'2%', justifyContent:'space-between', margin:'0px'}}>
          <div className='titreMoins' style={{margin:'0px', marginBottom:'10px'}}>Au jour de votre dernière observation, des symptomes de mildiou sont-il apparus ?</div>
          <div className='row' onChange={handleChangeQmildiouApparu} style={{justifyContent:'flex-start', marginBottom:'30px', marginLeft:'2%'}}>
            <input type="radio" value="oui" name="MildAppart" className='input_radio' defaultChecked={QmildiouApparu === "oui"} style={{    transform: "scale(3.5)", accentColor: "#C61717", marginRight: "30px" }}/>
            <div className='titreMoins' style={{margin:'0px'}}>Oui</div>
            <input type="radio" value="non" name="MildAppart" className='input_radio' defaultChecked={QmildiouApparu === "non"}style={{    transform: "scale(3.5)", accentColor: "#C61717", marginRight: "30px", marginLeft:'60px' }} />
            <div className='titreMoins' style={{margin:'0px'}}>Non</div>
          </div>
          <div className='row' style={{justifyContent:'flex-start', marginBottom:'30px', marginLeft:'2%'}}>
            <div className='titreMoins' style={{margin:'0px'}}>Date d'observation : </div>
            <input 
            className='input titreMoinsMoins'
            value={QdateApparition}
            onChange={handleChangeDateObser}
            type='date'
            style={{height:'80px', width:'50%', margin:'0px', marginLeft:'2%'}}
            />
          </div>
          <div className='titreMoins' style={{margin:'0px', marginBottom:'10px'}}>Avez-vous traité ?</div>
          <div className='row' onChange={handleChangeQtrait} style={{justifyContent:'flex-start', marginBottom:'30px', marginLeft:'2%'}}>
            <input type="radio" value="oui" name="MildTrait" className='input_radio' defaultChecked={Qtraite === "oui"} style={{    transform: "scale(3.5)", accentColor: "#C61717", marginRight: "30px" }}/>
            <div className='titreMoins' style={{margin:'0px'}}>Oui</div>
            <input type="radio" value="non" name="MildTrait" className='input_radio' defaultChecked={Qtraite === "non"}style={{    transform: "scale(3.5)", accentColor: "#C61717", marginRight: "30px", marginLeft:'60px' }} />
            <div className='titreMoins' style={{margin:'0px'}}>Non</div>
          </div>
          <div className='row' style={{justifyContent:'flex-start', marginBottom:'30px', marginLeft:'2%'}}>
            <div className='titreMoins' style={{margin:'0px'}}>Date de traitement : </div>
            <input 
            className='input titreMoinsMoins'
            value={QdateTrait}
            onChange={handleChangeDateTrait}
            type='date'
            style={{height:'80px', width:'50%', margin:'0px', marginLeft:'2%'}}
            />
          </div>
          <div className='titreMoins' style={{margin:'0px', marginBottom:'10px'}}>La prédiction d’alerte d’aujourd’hui vous parait-elle pertinente ? </div>
          <input className="custom-slider" style={{margin:'0px', height:'35px', width:'100%'}} type="range" id="cowbell" name="cowbell" min={1} max={4} value={QpertinencePreditc} step="1" onChange={handleChangePertience}/>
          <div className='titreMoins row' style={{margin:'0px', justifyContent:'space-between'}}> 
            <div style={{width:'20%', textAlign:'left'}}>Pas pertinente</div>
            <div style={{width:'20%', textAlign:'center'}}>Peu pertinente</div>
            <div style={{width:'20%', textAlign:'center'}}>Pertinente</div>
            <div style={{width:'20%', textAlign:'right'}}>Très pertinente</div>
          </div>

          <input 
          className='input'
          value={Qcommentaire}
          onChange={handleChangeCommentaire}
          placeholder='Laisser un commentaire'
          type='text'
          style={{marginBottom:'10px', height:'100px', marginTop:'30px'}}
          />
          
          <button className='validationMildiou'>
            <img src={plane} alt="flèche vers le bas" style={{width:'8%'}}/>
            <div className='texteValidationMildiou'> Enregistrer</div>
          </button>
        </div>

        <div className='divInfestation'>
          <div className='titre' style={{width:'100%', textAlign:'center', margin:'0px', marginBottom:'20px', color:'#C61717'}}>Sur la base de l’itinéraire climatique passé,</div>
          <div className='row'>
            <div className='row titreMoins' style={{width:'45%', textAlign:'center', margin:'0px', marginBottom:'20px', color:'#C61717'}}>
              le taux maximal d’infestation probable est de 
            </div>
            <div className='row titreMoins' style={{width:'45%', textAlign:'center', margin:'0px', marginBottom:'20px', color:'#C61717'}}>
              et pourra être atteint le 
            </div>
          </div>
          <div className='row' style={{alignItems:'flex-start'}}>
            <div className='row' style={{width:'45%'}}>
              <div className='carreInfo' style={{width:'80%', marginBottom:'5px'}}> {tauxMax} % </div>
            </div>
            <div className='row' style={{width:'45%'}}>
              <div className='carreInfo' style={{width:'80%', marginBottom:'5px'}}> {dateTauxMax === "/" ? "/" : formatDate(dateTauxMax)} </div>
            </div>
          </div>
          <div className='row' style={{alignItems:'flex-start', marginBottom:'0px'}}>
            <div className='row' style={{width:'45%', marginBottom:'0px'}}>
              <div className='titreMoins' style={{width:'100%', textAlign:'center', margin:'0px', color:'#C61717'}}>des ceps</div>
            </div>
            <div className='row' style={{width:'45%', marginBottom:'0px'}}>
              {/* laisser vide */}
            </div>
          </div>
          <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', paddingLeft:'2%',paddingRight:'2%'}}>
            <div style={{width:'70%'}}>
              {/* metrre le bouton plus d'infos */}
            </div>
            <select id="yearSelect" value={annee} onChange={handleChange} className='selectAnneeMildiou' style={{marginBottom:'20px'}}>
              <option value={anneeFixe}>{anneeFixe}</option>
              <option value={anneeFixe - 1}>{anneeFixe - 1}</option>
              <option value={anneeFixe - 2}>{anneeFixe - 2}</option>
              <option value={anneeFixe - 3}>{anneeFixe - 3}</option>
          </select>
          </div>
        </div>

        <div style={{backgroundColor:'#EAF5FE', width:'100hw'}}>
          <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', paddingLeft:'2%',paddingRight:'2%', paddingTop:'2%'}}>
            <div style={{width:'70%'}}>
              <div className='titre' style={{margin:'0px'}}>Mon rendement potentiel</div>
              <div className='titreMoinsMoins' > Mon objectif de rendement est de {rdtObjectif} hL</div>
            </div>
            <select id="yearSelect" value={annee} onChange={handleChange} className='selectAnneeMildiou'>
              <option value={anneeFixe}>{anneeFixe}</option>
              <option value={anneeFixe - 1}>{anneeFixe - 1}</option>
              <option value={anneeFixe - 2}>{anneeFixe - 2}</option>
              <option value={anneeFixe - 3}>{anneeFixe - 3}</option>
          </select>
          </div>
          <div style={{display:'flex', flexDirection:'row', justifyContent:'space-around'}}>
            <div style={{width:'45%', padding:'2%'}}>{dataRDT_N !== undefined ?
                <GraphCamembergRDTMildiou myData={dataRDT} />
              : "" }</div>
            <div style={{width:'45%', padding:'2%'}}>
              <div className='titreMoins'> Potentiel : </div>
              <div className='carreInfo' style={{width:'45%'}}> {rdtPotentiel} hL</div>
              <div style={{display:'flex', flexDirection:'row', justifyContent:'space-around', alignItems:'center', width:'100%'}} >
                <div className='carreLegend' style={{backgroundColor:"#5FC1AA"}}>
                  {/*laisser vide */}
                </div>
                <div className='paragraphe' style={{width:'85%', padding:'2%'}}>
                  Pertes Climatiques
                </div>
              </div>
              <div style={{display:'flex', flexDirection:'row', justifyContent:'space-around', alignItems:'center', width:'100%', marginTop:'10px'}} >
                <div className='carreLegend' style={{backgroundColor:"#247E5F"}}>
                  {/*laisser vide */}
                </div>
                <div className='paragraphe' style={{width:'85%', padding:'2%'}}>
                  Pertes Milidou
                </div>
              </div>
              <div style={{display:'flex', flexDirection:'row', justifyContent:'space-around', alignItems:'center', width:'100%', marginTop:'10px'}} >
                <div className='carreLegend' style={{backgroundColor:"#B2E1C7"}}>
                  {/*laisser vide */}
                </div>
                <div className='paragraphe' style={{width:'85%', padding:'2%'}}>
                  Récolte Résiduelle
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AccueilMildiou